import { useId } from "react";
import { useCatalog } from "@/lib/catalog/context.tsx";
import { TIER_RANK_MAX, TIER_RANK_MIN } from "@/lib/filters/types.ts";
import { setFilters, useFilters } from "@/state/filters.ts";
import styles from "./controls.module.css";

/**
 * The importance ceiling: how far down the tier list you're willing to go.
 * The ticks under the track are the tiers themselves, so the slider reads as
 * "stop here" rather than as a number.
 */
export function TierSlider() {
  const catalog = useCatalog();
  const filters = useFilters();
  const id = useId();

  const tiers = [...catalog.tiers].sort((a, b) => a.rank - b.rank);
  const active = tiers.find((t) => t.rank === filters.tierMax);
  const included = catalog.entries.filter(
    (e) => (tiers.find((t) => t.id === e.curation.tier)?.rank ?? TIER_RANK_MAX) <= filters.tierMax,
  ).length;

  return (
    <div className={styles.field}>
      <div className={styles.head}>
        <label className={styles.label} htmlFor={id}>
          Importance
        </label>
        <output className={styles.value} htmlFor={id}>
          {active?.label ?? "—"} &amp; up
        </output>
      </div>
      <input
        id={id}
        className={styles.range}
        type="range"
        min={TIER_RANK_MIN}
        max={TIER_RANK_MAX}
        step={1}
        value={filters.tierMax}
        aria-valuetext={`down to ${active?.label ?? filters.tierMax}, ${included} stops`}
        onChange={(event) =>
          setFilters((prev) => ({ ...prev, tierMax: Number(event.target.value) }))
        }
      />
      <ol className={styles.ticks} aria-hidden="true">
        {tiers.map((tier) => (
          <li
            key={tier.id}
            className={`${styles.tick} ${tier.rank <= filters.tierMax ? styles.tickOn : ""}`}
          >
            {tier.label}
          </li>
        ))}
      </ol>
      <p className={styles.hint}>{active?.description}</p>
    </div>
  );
}
